import { customHeaders, requestApi } from 'api/api'
import { v4 as uuidv4 } from 'uuid'
import { PayoutsV2PostAuthRequest, PayoutsV2PostAuthResponse } from 'types/payoutsV2'
import {
  UnifiedPayoutsV2FeeEstimate,
  UnifiedPayoutsV2Request,
} from 'types/unifiedPayouts/unifiedPayoutsV2'

export const postPayoutsPostAuthV2 = (
  data: PayoutsV2PostAuthRequest
): Promise<PayoutsV2PostAuthResponse> => {
  return requestApi({
    url: '',
    baseUrl: data?.mfaCallbackUrl,
    method: 'POST',
    data: {
      challenge: data?.challenge,
      tokenResponse: data?.tokenResponse,
    },
    headers: {
      ...customHeaders,
      'x-idempotency-key': uuidv4(),
    } as any,
  })
}

export const getPayoutsFeeEstimate = (
  data: UnifiedPayoutsV2Request
): Promise<UnifiedPayoutsV2FeeEstimate> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v2/payouts/fee-estimation',
    method: 'POST',
    data,
  })
}
